export const version = "ethers/5.2.0";
//# sourceMappingURL=_version.js.map